export default __webpack_public_path__ + "static/media/40165.bcd1cc89.jpg";